import { render, staticRenderFns } from "./Asset-snapshot-board.vue?vue&type=template&id=65ff8497&scoped=true&"
import script from "./Asset-snapshot-board.vue?vue&type=script&lang=js&"
export * from "./Asset-snapshot-board.vue?vue&type=script&lang=js&"
import style0 from "./Asset-snapshot-board.vue?vue&type=style&index=0&id=65ff8497&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ff8497",
  null
  
)

export default component.exports